import styled from "styled-components"
import constants from "utils/constants"

export default function VendorProfileHeader({ vendorProfileImg, companyName }) {
  return (
    <>
      <ProfileImgWrapper>
        <ProfileImg
          src={`${constants["imagePath"]}/commerce/vendor/profile_img/${vendorProfileImg}`}
          alt={`${companyName} logo`}
        />
      </ProfileImgWrapper>
      <Spacer />
    </>
  )
}

const ProfileImgWrapper = styled.div`
  position: absolute;
  top: calc(100vw * (-25 / 375));
  width: calc(100vw * (65 / 375));
  height: calc(100vw * (65 / 375));
  border: 1px solid #efefef;
  border-radius: 100%;
  overflow: hidden;
  background-color: #fff;
  margin-right: calc(100vw * (10 / 375));
`

const ProfileImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

const Spacer = styled.div`
  height: calc(100vw * (40 / 375));
  margin-bottom: calc(100vw * (12 / 375));
`
